import {
    type ChargingStation,
    ChargePointParkingScenario,
    ConnectorStandard,
    ConnectorPlugType,
    ConnectorPowerType,
    ConnectorStatus,
    ContractType,
    Currency,
    CurrencyDimension,
    TruckClassification,
} from '../../../src/store/facade/facadeApiV3';

export const chargePointData: ChargingStation = {
    id: '5eedc6d3-1d05-4430-9c81-2dedeef5f3e9',
    name: 'Hostal Río Deva II - Unquera',
    operator: {
        id: '0dabc935-83ab-42bb-9d10-fb9972f4f695',
        name: 'GRUPO EASYCHARGER S.A.',
    },
    address: {
        street: 'N-634, 33A s/n',
        city: 'Unquera',
        countryCode: 'ESP',
        postalCode: '39548',
    },
    location: {
        latitude: 43.374832,
        longitude: -4.500147,
    },
    maxPower: 360,
    truckClassification: TruckClassification.TruckReady,
    supportPhone: '',
    stationContracts: ['TCS'],
    chargePoints: [
        {
            chargePointId: '694fb628-effc-4132-b45a-3fe6563a87a9',
            parkingRestrictions: {
                parkingScenario: ChargePointParkingScenario.DriveThrough,
            },
            supportsRemoteAuthentication: true,
            connectors: [
                {
                    id: 'd385762e-272b-4d08-8f98-bf12e021a3d1',
                    evseId: 'ES*ZUN*E3901ER1',
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 150,
                    truckClassification: TruckClassification.TruckReady,
                    voltage: 0,
                    current: 0,
                    status: ConnectorStatus.Available,
                    prices: [
                        {
                            price: '0.35',
                            contractType: ContractType.Tcs,
                            tariffId: '04b3de6c-402c-47cc-8dca-71bc264340f0',
                            currency: Currency.Eur,
                            currencyDimension: CurrencyDimension.Energy,
                        },
                    ],
                },
                {
                    id: '513dfb17-3c41-4785-b525-4161b8be3698',
                    evseId: 'ES*ZUN*E3901ER6',
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 360,
                    truckClassification: TruckClassification.TruckReady,
                    voltage: 0,
                    current: 0,
                    status: ConnectorStatus.Occupied,
                    prices: [
                        {
                            price: '0.35',
                            contractType: ContractType.Tcs,
                            tariffId: '04b3de6c-402c-47cc-8dca-71bc264340f0',
                            currency: Currency.Eur,
                            currencyDimension: CurrencyDimension.Energy,
                        },
                    ],
                },
                {
                    id: '7fbb6659-36d5-41f1-b66b-f0b3f1d5e776',
                    evseId: 'ES*ZUN*E3901ER5',
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 360,
                    truckClassification: TruckClassification.TruckReady,
                    voltage: 0,
                    current: 0,
                    status: ConnectorStatus.Available,
                    prices: [
                        {
                            price: '0.35',
                            contractType: ContractType.Tcs,
                            tariffId: '04b3de6c-402c-47cc-8dca-71bc264340f0',
                            currency: Currency.Eur,
                            currencyDimension: CurrencyDimension.Energy,
                        },
                    ],
                },
                {
                    id: '0d576e1c-d6af-4be7-8ec2-6ca9e6168cdb',
                    evseId: 'ES*ZUN*E3901ER2',
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 150,
                    truckClassification: TruckClassification.TruckReady,
                    voltage: 0,
                    current: 0,
                    status: ConnectorStatus.Occupied,
                    prices: [
                        {
                            price: '0.35',
                            contractType: ContractType.Tcs,
                            tariffId: '04b3de6c-402c-47cc-8dca-71bc264340f0',
                            currency: Currency.Eur,
                            currencyDimension: CurrencyDimension.Energy,
                        },
                    ],
                },
                {
                    id: '249ed3b7-8397-482b-a862-40545c4e60fe',
                    evseId: 'ES*ZUN*E3901ER3',
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 360,
                    truckClassification: TruckClassification.TruckReady,
                    voltage: 0,
                    current: 0,
                    status: ConnectorStatus.Occupied,
                    prices: [
                        {
                            price: '0.35',
                            contractType: ContractType.Tcs,
                            tariffId: '04b3de6c-402c-47cc-8dca-71bc264340f0',
                            currency: Currency.Eur,
                            currencyDimension: CurrencyDimension.Energy,
                        },
                    ],
                },
                {
                    id: '7cef79da-f351-49b3-a523-c46ac3cdec9a',
                    evseId: 'ES*ZUN*E3901ER4',
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 360,
                    truckClassification: TruckClassification.TruckReady,
                    voltage: 0,
                    current: 0,
                    status: ConnectorStatus.Available,
                    prices: [
                        {
                            price: '0.35',
                            contractType: ContractType.Tcs,
                            tariffId: '04b3de6c-402c-47cc-8dca-71bc264340f0',
                            currency: Currency.Eur,
                            currencyDimension: CurrencyDimension.Energy,
                        },
                    ],
                },
            ],
        },
    ],
};
